import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { AthleteAutoComplete, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAutoCompleteAthleteProps {
  search?: string;
}

function useAutoCompleteAthlete({
  search,
}: IUseAutoCompleteAthleteProps): UseQueryResult<{ data: Array<AthleteAutoComplete> }> {
  const fetchAutoCompleteAthlete = (): Promise<AxiosResponse<{ data: Array<AthleteAutoComplete> }>> => {
    const params: UrlParams = { limit: '100', offset: '0' };

    if (search) {
      params.search = search;
    }

    return client.get(`athletes/auto_complete/?${encodeUrlParams(params)}`);
  };

  return useQuery(['athletesAC', search], fetchAutoCompleteAthlete);
}

export default useAutoCompleteAthlete;
